import CampaignBudgetApi from '@/api/CampaignBudget'

export class CampaignBudgetRepository {
  static async getByCampaignId(id) {
    return await CampaignBudgetApi.getByCampaignId(id)
  }
}
